import { EventDetail } from "../../_interfaces/eventDetail";
import { IEventFormatter } from "./ievent-formatter";

export class AssignmentFormatter implements IEventFormatter {
  public format(properties: any, type_id: string): EventDetail[] {
    const formattedMessages: EventDetail[] = [];

    console.log("AssignmentFormatter formatting event:", type_id, properties);

    switch (type_id) {
      case 'People.team.assignment':
        formattedMessages.push({
          key: 'EVENTS.ASSIGNMENT.PERSON_ASSIGNED',
          params: {
            personName: properties.person.name,
            teamName: properties.team.name,
            allocationRate: properties.assignment_details.allocation_rate
          }
        });
        break;
      case 'Team.person.add':
        formattedMessages.push({
          key: 'EVENTS.ASSIGNMENT.MEMBER_ADDED',
          params: {
            personName: properties.person.name,
            allocationRate: properties.assignment_details.allocation_rate
          }
        });
        break;

      case 'People.team.unassignment':
        formattedMessages.push({
          key: 'EVENTS.ASSIGNMENT.PERSON_UNASSIGNED',
          params: { 
            personName: properties.person.name,
            teamName: properties.team.name }
        });
        break;
      case 'Team.person.remove':
        formattedMessages.push({
          key: 'EVENTS.ASSIGNMENT.MEMBER_REMOVED',
          params: { personName: properties.person.name }
        });
        break;

      case 'People.team.assignment.update':
      case 'Team.person.assignment.update':
        const keyPrefix = type_id.startsWith('People') ? 'PERSON' : 'MEMBER';
        properties.change_summary.forEach((change: any) => {
          formattedMessages.push({
            key: this.getUpdateTranslationKey(change.field, keyPrefix),
            params: {
              personName: properties.person.name,
              teamName: properties.team.name,
              oldValue: change.old_value,
              newValue: change.new_value
            }
          });
        });
        break;
    }

    return formattedMessages;
  }

  private getUpdateTranslationKey(field: string, prefix: string): string {
    const fieldKey = field.toUpperCase();
    return `EVENTS.ASSIGNMENT.UPDATE.${prefix}.${fieldKey}`;
  }
}
